import { debounce, getWindowScrollTop } from "../functions.js";

const SCROLL_UP_SENSIVITY = 10;
export default function HeaderModule(element) {

    let initiallyInverted = document.body.classList.contains('invert-header');

    function isMenuActive() {
        // @todo: ver que implica isMenuActive
        return false;
        return element.classList.contains('active');
    }

    function isMobileMenu() {
        return window.innerWidth <= 1100;
    }

    var lastScrollTop = 0;

    function checkScroll() {

        let windowScrollTop = Math.max(getWindowScrollTop(), 0);

        if (windowScrollTop >= 100) {
            document.body.classList.add('has-scrolled');
            if (!initiallyInverted) {
                document.body.classList.add('invert-header');
            }
        } else {
            document.body.classList.remove('has-scrolled');
            if (!initiallyInverted) {
                document.body.classList.remove('invert-header');
            }
        }

        if (isMobileMenu() && isMenuActive()) {
            return;
        }

        let scrolledSinceLastCheck = Math.abs(windowScrollTop - lastScrollTop);

        let scrollDirection = windowScrollTop > lastScrollTop ? 'down' : 'up';

        if (scrolledSinceLastCheck >= SCROLL_UP_SENSIVITY) {
            if (scrollDirection === 'up') {
                document.body.classList.remove('hide-header');
            } else { // === 'up'
                document.body.classList.add('hide-header');
            }
        }

        lastScrollTop = windowScrollTop;
        
    }

    function initHeaderScrollCheck() {
        // console.log('initHeaderScrollCheck');
        let scrollTimeout = null;
        window.addEventListener('scroll', function() {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(checkScroll, 200);
        });
        checkScroll();
    }

    initHeaderScrollCheck();
    
}
